<template>
  <el-container>
    <el-card shadow="never">
      <el-row>
        <el-form inline :model="form" ref="formRef">
          <el-form-item label="奖品名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="审核状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择状态" class="!w-[200px]">
              <el-option label="全部" value="" />
              <el-option label="待审核" value="1" />
              <el-option label="审核通过" value="2" />
              <el-option label="审核驳回" value="3" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleAdd">添加</el-button>
        <el-button type="default" @click="returnList">返回</el-button>
      </el-row>
    </el-card>

    <NbTableV2 ref="tableRef" v-model:page="form.page" v-model:pageSize="form.pageSize" :loading="loading"
      :data="tableData" :total="total" :columns="columns" :isBottom="true" :isTop="false" :config="{
        border: true,
      }" @getList="getList" @getRows="handleGetRows">
      <template #type="{ row }">
        {{ row.type === 1 ? '实物' : '优惠券' }}
      </template>
      <!-- 奖品图片插槽 -->
      <template #image="{ row }">
        <el-image :src="row.image" fit="cover" style="width: 50px; height: 50px;"/>
      </template>
      <template #time="{ row }">
        <p>{{ row.start_time }}</p>
        <p>~</p>
        <p>{{ row.end_time }}</p>
      </template>
      <!-- 是否有惊喜插槽 -->
      <template #is_surprise="{ row }">
        <!-- 1无惊喜奖品2有惊喜奖品	 -->
         {{ row.is_surprise === 1? '否' : '是' }}
      </template>
      <!-- 掉落概率插槽 -->
      <template #probability="{ row }">
        {{ row.probability }}%
      </template>
      <!-- 状态插槽 -->
      <template #status="{ row }">
        <small-dot-v2 :type="row.status === 1? 'primary' : row.status === 2?'success' : 'danger'">{{ row.status === 1? '待审核' : row.status === 2? '审核通过' : '审核驳回' }}</small-dot-v2>
      </template>

      <!-- 操作插槽 -->
      <template #operate="{ row }">
        <el-button type="primary" link @click="handleEdit(row, false)" v-if="row.status !== 2">编辑</el-button>
        <el-button type="primary" link @click="handleEdit(row, true)" v-if="row.status === 2">查看</el-button>
        <el-button type="primary" link @click="handleData(row)">数据</el-button>
        <el-button type="danger" link @click="handleDelete(row)" v-if="row.status !== 2">删除</el-button>
      </template>
      <!-- v-if="isShowDelete" -->
    </NbTableV2>
  </el-container>

  <AddPrize ref="addPrizeRef" :startTime="startTime" :endTime="endTime" @refresh="getList" />
  <el-dialog v-model="dataDialogVisible" title="奖品数据" width="80%" @close="handleDataDialogClose">
    <!-- 这里可以根据需要显示活动数据 -->
    <el-table :data="currentPrizeData" border>
      <el-table-column prop="day" label="日期" />
      <el-table-column prop="uv" label="商品访问UV" />
      <el-table-column prop="action_user_num" label="参与抢拍人数（去重）" />
      <el-table-column prop="action_num" label="参与抢拍次数" />
      <el-table-column prop="surprise_num" label="惊喜奖励获得次数" />
      <el-table-column prop="surprise_user_num" label="惊喜奖励获得人数（去重）" />
      <el-table-column prop="action_max_points" label="当日最高出价" />
    </el-table>
    <!-- 添加分页组件 -->
    <el-pagination class="prize-data-pagination" v-model:current-page="currentPrizeDataPage"
      v-model:page-size="currentPrizeDataPageSize" :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper" :total="totalPrizeData"
      @size-change="handlePrizeDataPageSizeChange" @current-change="handlePrizeDataPageChange" />
    <!-- 可以添加更多数据显示项 -->
    <template #footer>
      <el-button @click="dataDialogVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import NbTableV2 from '@/components/table/components/NbTableV2.vue'
import AddPrize from './components/AddPrize.vue'
import service from './service'
import { ElMessageBox, ElMessage } from 'element-plus'
import SmallDotV2 from '@/components/table/components/SmallDotV2.vue'
import { DEFAULT_IMAGE } from '@/assets/common/config'

const form = ref({
  activity_id: '',
  name: '',
  status: '',
  page: 1,
  pageSize: 10
})

// 数据弹窗
const dataDialogVisible = ref(false);
// 当前奖品数据
const currentPrizeData = ref([]);
// 当前奖品数据page
const currentPrizeDataPage = ref(1);
// 当前奖品数据pageSize
const currentPrizeDataPageSize = ref(10);
// 奖品数据总数
const totalPrizeData = ref(0);

const startTime = ref('');
const endTime = ref('');

const route = useRoute()
const router = useRouter()
console.log(route.query.status, 'status')
const isShowDelete = computed(() => {
  return route.query.status == 1
})

const tableRef = ref(null)
const tableData = ref([])
const loading = ref(false)
const total = ref(0)
const selectedRows = ref([])

const addPrizeRef = ref(null)

// 表格列配置
const columns = [
  {
    prop: 'name',
    label: '奖品名称',
    align: 'left',
    minWidth: '150',
    headerAlign: 'center'
  },
  {
    prop: 'type',
    label: '奖品类型',
    align: 'center',
    minWidth: '100',
    headerAlign: 'center',
    slot: 'type'
  },
  {
    label: '奖品图片',
    align: 'center',
    minWidth: '100',
    slot: 'image',
    headerAlign: 'center'
  },
  {
    prop: 'real_price',
    label: '参考价值',
    align: 'right',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'num',
    label: '奖品数量',
    align: 'right',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'has_num',
    label: '剩余数量',
    align: 'right',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'time',
    label: '抢拍时间',
    align: 'center',
    slot: 'time',
    minWidth: '180',
    headerAlign: 'center'
  },
  {
    prop: 'default_points',
    label: '起拍价格',
    align: 'right',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'minimum_point',
    label: '最低加价',
    align: 'right',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'is_surprise',
    label: '是否有惊喜',
    align: 'center',
    slot: 'is_surprise',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'probability',
    label: '掉落概率',
    align: 'right',
    slot: 'probability',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    prop: 'status',
    label: '审核状态',
    align: 'right',
    slot: 'status',
    minWidth: '100',
    headerAlign: 'center'
  },
  {
    label: '操作',
    align: 'left',
    minWidth: '120',
    slot: 'operate',
    headerAlign: 'center',
    fixed: 'right'
  }
]

onMounted(() => {
  form.value.activity_id = route.query.activity_id
  startTime.value = route.query.start_time
  endTime.value = route.query.end_time
  getList()
})

const handleSearch = () => {
  form.value.page = 1
  getList()
}


// 获取列表数据
const getList = async () => {
  loading.value = true
  try {
    // TODO: 调用接口获取数据
    const res = await service.getPrizesList(form.value)
    tableData.value = res.list
    total.value = res.total
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}

// 处理获取选中行
const handleGetRows = (rows) => {
  selectedRows.value = rows
}

// 添加奖品
const handleAdd = () => {
  // TODO: 实现添加奖品逻辑
  addPrizeRef.value.openDialog(route.query.activity_id)
}

// 返回列表
const returnList = () => {
  router.push({ path: '/grabAndShoot/activitylist' })
}

// 编辑奖品
const handleEdit = (row, disabledFlg) => {
  // TODO: 实现编辑奖品逻辑
  addPrizeRef.value.openDialog(route.query.activity_id, row.id, disabledFlg)
}

// 查看奖品数据
const handleData = (row) => {
  currentPrizeDataPage.value = 1;
  fetchPrizeData(row.id);
}

// 获取奖品数据
const fetchPrizeData = async (prizeId) => {
  const params = {
    prize_id: prizeId,
    page: currentPrizeDataPage.value,
    pageSize: currentPrizeDataPageSize.value
  }
  try {
    const res = await service.getShopPrizeData(params)
    if (res) {
      currentPrizeData.value = res.list;
      totalPrizeData.value = res.total;
      dataDialogVisible.value = true;
    }
  } catch (error) {
    console.error(error)
  }
}

// 处理页码变化
const handlePrizeDataPageChange = (page) => {
  currentPrizeDataPage.value = page;
  fetchPrizeData(currentSelectedPrizeId.value);
}

// 处理每页数量变化
const handlePrizeDataPageSizeChange = (pageSize) => {
  currentPrizeDataPageSize.value = pageSize;
  fetchPrizeData(currentSelectedPrizeId.value);
}

// 关闭对话框时重置分页信息
const handleDataDialogClose = () => {
  currentPrizeData.value = [];
  totalPrizeData.value = 0;
  dataDialogVisible.value = false;
  currentPrizeDataPage.value = 1;
  currentPrizeDataPageSize.value = 10;
}

// 删除奖品
const handleDelete = (row) => {
  ElMessageBox.confirm(`确认要删除【${row.name}】吗？`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      const res = await service.deletePrizes({ prize_id: row.id })
      if (!res) return
      ElMessage.success('操作成功')
      getList()
    } catch (error) {
      console.error(error)
      ElMessage.error('删除失败')
    }
  }).catch(() => { })
}

// 批量删除奖品
const handleBatchDelete = () => {
  ElMessageBox.confirm('确认要删除选中的奖品吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      const res = await service.batchDeletePrizes({ prizeIds: selectedRows.value.map(item => item.id).join(',') })
      if (!res) return
      ElMessage.success('操作成功')
      selectedRows.value = []
      tableRef.value.clearSelection()
      getList()
    } catch (error) {
      console.error(error)
      ElMessage.error('删除失败')
    }
  }).catch(() => { })
}

</script>

<style scoped>
.el-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 新增样式让分页器居右 */
.prize-data-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  /* 可根据需要调整顶部间距 */
}
</style>